import { generatePath } from 'react-router-dom';
import groupBy from 'lodash/groupBy';

import { tag } from '@legacyUrls';
import { OnSaggestsPayload } from '@containers/SearchSuggests';

export const getSuggestsAnalyticsData = ({
  suggests,
  categoriesSuggests,
  suggestsInCategories,
} : OnSaggestsPayload) => {
  const {
    commonSuggests,
    tagsSuggests,
  } = groupBy(suggests, (item) => item.replacementOfSuggest ? 'tagsSuggests' : 'commonSuggests');

  const blocksMap = new Map<string, { count: number, queries: string[] }>();

  if (commonSuggests?.length) {
    blocksMap.set('suggest_common', {
      count: commonSuggests.length,
      queries: commonSuggests.map((item) => item.search),
    });
  }

  if (tagsSuggests?.length) {
    blocksMap.set('suggest_tag', {
      count: tagsSuggests.length,
      queries: tagsSuggests.map((t) => generatePath(tag, { slug: t.replacementOfSuggest!.slug })),
    });
  }

  if (categoriesSuggests.length) {
    blocksMap.set('suggest_choose_category', {
      count: categoriesSuggests.length,
      queries: categoriesSuggests.map((item) => item.name),
    });
  }

  if (suggestsInCategories.length) {
    blocksMap.set('suggest_in_category', {
      count: suggestsInCategories.length,
      queries: suggestsInCategories.map((item) => item.name),
    });
  }

  return {
    suggestsBlocks: Array.from(blocksMap.keys()),
    suggestsCount: Array.from(blocksMap.values(), (value) => value.count),
    searchQuery: Array.from(blocksMap.values(), (value) => value.queries).flat(),
  };
};
